// Manages: Firebase Auth (login, logout, auth state)
import { login, logout, onAuthChange, getUserProfile } from '@/lib/firebase';

export const authService = {
  login(email, password) {
    return login(email, password);
  },
  logout() {
    return logout();
  },
  onAuthChange(callback) {
    return onAuthChange(callback);
  },
  getUserProfile(uid) {
    return getUserProfile(uid);
  },
};
